import parsePhoneNumber from 'libphonenumber-js';
import countriesList from '../../json/countries.json';

/* country name (as stored on the workspace / information) => ISO code, e.g. "Malaysia" => "MY" */
export const countryCode = (country) => {
  if (!country) return null;
  const res = countriesList.find(x => x.name === country);
  return res ? res.code : null;
}

/*
 * Normalizes a phone number into E.164 ("+<country calling code><national number>").
 *
 * Excel's default General cell format drops the leading "+" (and any leading "0"), so a
 * spreadsheet value reaches us either as a national number ("124709699") or as an
 * international one that lost its "+" ("60124709699", "6584585659"). Reading it as a
 * national number of `defaultCountry` first and only then as an international number
 * keeps both readings correct without asking the user to reformat the spreadsheet.
 * Anything that is not a valid number under either reading is left untouched.
 */
export const normalizePhoneNumber = (value, defaultCountry) => {
  let phoneNumber = value;

  if (typeof phoneNumber === 'number') {
    phoneNumber = String(phoneNumber);
  } else if (typeof phoneNumber !== 'string' || !phoneNumber.trim()) {
    return value;
  }
  phoneNumber = phoneNumber.trim();

  try {
    /* already international */
    if (phoneNumber.startsWith('+')) {
      const international = parsePhoneNumber(phoneNumber);
      return international && international.isValid() ? international.number : value;
    }
    /* national number of the default country */
    if (defaultCountry) {
      const national = parsePhoneNumber(phoneNumber, defaultCountry);
      if (national && national.isValid()) return national.number;
    }
    /* international number that lost its "+" */
    const digits = phoneNumber.replace(/[^0-9]/g, '');
    if (digits) {
      const international = parsePhoneNumber(`+${digits}`);
      if (international && international.isValid()) return international.number;
    }
  } catch(err) {
    console.error(err);
  }

  return value;
}
